export const CSS_CLASSES = {
  SELECT_POPOVER_ANCHOR: "select-popover-anchor",
  SELECT_POPOVER_ANCHOR_FORM_CONTROL: "select-popover-anchor-form-control",

  SELECT_INPUT: "select-input",
  SELECT_INPUT_DISABLED: "select-input-disabled",
  SELECT_INPUT_PLACEHOLDER: "select-input-placeholder",
  SELECT_INPUT_MULTI: "select-input-multi",

  SELECT_INPUT_ENHANCER: "select-input-enhancer",
  SELECT_INPUT_ENHANCER_BUTTON: "select-input-enhancer-button",

  SELECT_OPTIONS_LIST: "select-options-list",

  SELECT_OPTION_LIST_ITEM: "select-options-list-item",
  SELECT_OPTION_GROUP_LABEL_ITEM: "select-options-group-label-item",
  SELECT_OPTION_GROUP_LIST_ITEM: "select-options-group-list-item",

  SELECT_OPTION_LIST_ITEM_DEFAULT: "select-options-list-item-default",
  SELECT_OPTION_LIST_ITEM_HIGHLIGHTED: "select-options-list-item-highlighted",
  SELECT_OPTION_LIST_ITEM_HIGHLIGHTED_PRIMARY: "select-options-list-item-highlighted-primary",
  SELECT_OPTION_LIST_ITEM_DISABLED: "select-options-list-item-disabled",

  SELECT_INPUT_TAG_LIST: "select-input-tag-list",
  SELECT_INPUT_TAG_LIST_ITEM: "select-input-tag-list-item",

  // Listbox
  LISTBOX: "listbox",

  // Listbox Options Group
  LISTBOX_OPTIONS_GROUP_LABEL: "listbox-options-group-label",

  // Listbox Option Content
  LISTBOX_OPTION_CONTENT: "listbox-option-content",
  LISTBOX_OPTION_CONTENT_HIGHLIGHTED: "listbox-option-content-highlighted",
  LISTBOX_OPTION_CONTENT_HIGHLIGHTED_PRIMARY: "listbox-option-content-highlighted-primary",
  LISTBOX_OPTION_CONTENT_SELECTED: "listbox-option-content-selected",
  LISTBOX_OPTION_CONTENT_DISABLED: "listbox-option-content-disabled",
  LISTBOX_OPTION_CONTENT_GROUPED: "listbox-option-content-grouped",
};
